webpackJsonp([32390779784604],{

/***/ 212:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(11);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _reactReveal = __webpack_require__(18);
	
	var _reactAnchorLinkSmoothScroll = __webpack_require__(45);
	
	var _reactAnchorLinkSmoothScroll2 = _interopRequireDefault(_reactAnchorLinkSmoothScroll);
	
	var _SiteConfig = __webpack_require__(5);
	
	var _SiteConfig2 = _interopRequireDefault(_SiteConfig);
	
	var _SEO = __webpack_require__(24);
	
	var _SEO2 = _interopRequireDefault(_SEO);
	
	var _Footer = __webpack_require__(16);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _Container = __webpack_require__(23);
	
	var _Container2 = _interopRequireDefault(_Container);
	
	var _hero = __webpack_require__(31);
	
	var _hero2 = _interopRequireDefault(_hero);
	
	var _pageModule = __webpack_require__(53);
	
	var _pageModule2 = _interopRequireDefault(_pageModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Page = function Page() {
	  return _react2.default.createElement(
	    'div',
	    { className: 'container project-container' },
	    _react2.default.createElement(_reactHelmet2.default, { title: '' + _SiteConfig2.default.siteTitle }),
	    _react2.default.createElement(
	      'div',
	      { className: _pageModule2.default.headerWrapper },
	      _react2.default.createElement(_hero2.default, { cover: '../pictures/varna/hero.jpg', title: 'Varna Library', link: '#content' })
	    ),
	    _react2.default.createElement(
	      'div',
	      { style: { display: 'flex', flexDirection: 'row' } },
	      _react2.default.createElement(
	        'p',
	        { id: 'content', style: { width: '30%', marginLeft: '18%' } },
	        'The aim is to design a new public building typol- ogy for the interactive city life of 21C. Our driving motivation is architecturally guided structural op- timization in order to achieve interaction between fac\u0327ade, columns and slabs. Vertical force flow of'
	      ),
	      _react2.default.createElement(
	        'p',
	        { style: { width: '30%', marginRight: '18%' } },
	        'the building is expressed by the wooden fac\u0327ade which acts as an external supportive structure of the building. The horizontal flow inside each slab corresponds to this.'
	      )
	    ),
	    _react2.default.createElement('img', { src: '../pictures/varna/first.jpg', alt: 'Stairways inside the library' }),
	    _react2.default.createElement('img', { src: '../pictures/varna/diagram.png', alt: 'Diagrams explaining the library' }),
	    _react2.default.createElement(
	      'div',
	      { style: { display: 'flex', flexDirection: 'row' } },
	      _react2.default.createElement(
	        'p',
	        { id: 'content', style: { width: '30%', marginLeft: '18%' } },
	        'The wooden structure formed around the build- ing, act as a louver system navigating a comfortable light into the library. It also co-relate with the horizontal structural elements forming a functionally articulated space.'
	      ),
	      _react2.default.createElement(
	        'p',
	        { style: { width: '30%', marginRight: '18%' } },
	        'We use new and innovative simulation technology in order to engineer strong, thin and light weight wooden composite which is capable to withstand all necessary load cases.'
	      )
	    ),
	    _react2.default.createElement('img', { src: '../pictures/varna/second.jpg', alt: 'Interior of the library' }),
	    _react2.default.createElement(_Footer2.default, null)
	  );
	};
	exports.default = Page;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-varna-jsx-54d490390be659cecf45.js